import React, { useCallback, useEffect, useState } from 'react';
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer, Legend} from 'recharts';
import DashboardServices from 'services/DashboardServices';

const IncidentStatusCount = ({filters}) => {
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const getData = useCallback(async () => {
        setLoaded(false);
        const response = await DashboardServices.getIncidentStatusCount(filters);
        console.log("API Response:", response); // Log the response
        if (response.success) {
            // Convert count to number
            const formattedData = response.data.map(item => ({
                ...item,
                count: Number(item.count)
            }));
            setData(formattedData);
            setLoaded(true);
        }
    }, [filters]);

    useEffect(() => {
        getData();
    }, [getData]);

    const colorArray = [
        ['#ff4800', '#ff3700'],
        ['#0054da', '#0073de'],
        ['#f5b207ff', '#f5bd07'],
        ['#a18cd1', '#fbc2eb'],
        ['#d4fc79', '#96e6a1'],
        ['#f5576c', '#f093fb']
    ];

    return (
        <div className='w-full'>
            {loaded && (
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <defs>
                            {colorArray.map((colors, index) => (
                                <linearGradient key={index} id={`color${index}`} x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={colors[0]} stopOpacity={0.8} />
                                    <stop offset="95%" stopColor={colors[1]} stopOpacity={0.6} />
                                </linearGradient>
                            ))}
                        </defs>
                        <Pie
                            data={data}
                            dataKey="count"
                            nameKey="status"
                            cx="50%"
                            cy="100%" // Adjust to make it a half pie
                            startAngle={180}
                            endAngle={0}
                            outerRadius={145}
                            fill="#8884d8"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={`url(#color${index})`} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(value, name) => [`${value}`, name]} />
                        <Legend verticalAlign="bottom" height={36} />
                    </PieChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default IncidentStatusCount;